import FeatureSwitchCheck from "./FeatureSwitchCheck";


export default class BooleanFlag extends FeatureSwitchCheck<boolean> {

  public check(): boolean {
    return this.featureValue || false;
  }

  protected parseFeatureValue(featureSwitchValue: string | undefined): boolean | undefined {
    return featureSwitchValue?.toLowerCase() === "true";
  }

}
